import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function PageShell({ children, testId }) {
  return (
    <div className="App min-h-screen bg-bde-cream text-bde-ink" data-testid={testId}>
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
